import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BasePage } from 'src/app/core/base-page';
import { AppSettings } from 'src/app/core/configs/app.settings';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { Utilities } from 'src/app/core/helper/util';
import { AuthenticationService } from '../../data/service/authentication.service';

@Component({
  selector: 'app-request-reset-form',
  templateUrl: './request-reset-form.component.html',
  styleUrls: ['./request-reset-form.component.scss'],
})
export class RequestResetFormComponent extends BasePage {

  // this is email coming from login screen so user doesn't have to re-enter
  @Input() email: string;
  @Input() phone: string;

  // Page outputs
  @Output() loginClicked = new EventEmitter();
  @Output() registerClicked = new EventEmitter();

  emailEntered = false;
  phoneChosen = false;
  step = 1;

  constructor(authService: AuthenticationService) {
    super(authService);
  }

  get version() { return AppSettings.version; }

  async reset() {
    if (String.isNullOrWhiteSpace(this.email)) {
      ServiceHelper.displayAlert('Missing Email', 'Doh! You must enter your email address in order to request a reset!');
    } else if (Utilities.isValidEmail(this.email || '') === false) {
      ServiceHelper.displayAlert('Invalid Email', 'Doh! You must enter a valid email address in order to request a reset!');
    } else {
      const loading = await ServiceHelper.displayLoad('Requesting Reset... ');
      try {
        this.pageState.busy = true;
        // send the request
        const request = {
          email: this.email,
          phone: this.phone,
          fromDash: true
        };

        await this.authService?.requestReset(request);
        await loading?.dismiss();
        this.step = 2;
      } catch (error: any) {
        console.error('Error requesting reset', error);
        ServiceHelper.displayAlert('Reset Error', error);
        loading?.dismiss();
      } finally {
        this.pageState.busy = false;
      }
    }
  }

  goToCreate() {
    this.registerClicked.emit();
  }

  goToLogin() {
    this.loginClicked.emit();
  }

}

